var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "tax-configuration-group-tax-reform-enabled",
                  name: "taxReformEnabled",
                  type: "switch",
                  label: _vm.$t("Configurar tributos da reforma nesta exceção"),
                  instruction: _vm.$t(
                    "Desligado, o produto usa o parâmetro fiscal do NCM. Ao ligar, os campos vêm preenchidos com essa configuração para você ajustar."
                  ),
                },
                model: {
                  value: _vm.taxReformEnabled,
                  callback: function ($$v) {
                    _vm.taxReformEnabled = $$v
                  },
                  expression: "taxReformEnabled",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.taxReformEnabled
        ? _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "tax-configuration-group-st-cbs-ibs",
                          name: "stCbsIbsCode",
                          type: "vue-select",
                          options: _vm.comboCst,
                          placeholder: _vm.$t("Mantém o do NCM"),
                          label: _vm.$t("Situação Trib. CBS/IBS"),
                          instruction: _vm.$t(
                            "Quando informada, todo o bloco de CBS/IBS desta exceção substitui o do parâmetro fiscal do NCM"
                          ),
                        },
                        model: {
                          value: _vm.form.stCbsIbsCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "stCbsIbsCode", $$v)
                          },
                          expression: "form.stCbsIbsCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "5" } },
                    [
                      _c("FormulateInput", {
                        class: _vm.hasCbsIbs ? "required" : "",
                        attrs: {
                          id: "tax-configuration-group-fiscal-classification-cbs-ibs",
                          name: "fiscalClassificationCbsIbsCode",
                          type: "vue-select",
                          options: _vm.comboCbsIbsClassTribs,
                          placeholder: _vm.$t("Selecione"),
                          disabled: !_vm.hasCbsIbs,
                          validation: _vm.hasCbsIbs ? "required" : "",
                          label: _vm.$t("Classificação CBS/IBS"),
                        },
                        model: {
                          value: _vm.form.fiscalClassificationCbsIbsCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "fiscalClassificationCbsIbsCode",
                              $$v
                            )
                          },
                          expression: "form.fiscalClassificationCbsIbsCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.cbsIbsRatesVisible
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            staticClass: "required",
                            attrs: {
                              id: "tax-configuration-group-cbs-percent",
                              name: "cbsPercent",
                              type: "text-percetage",
                              currency: "%",
                              precision: 5,
                              validation: "required|number|min:0.0000|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                              label: _vm.$t(
                                "FISCAL_TAX_PARAMETER.LABEL.CBS_PERCENT"
                              ),
                            },
                            model: {
                              value: _vm.form.cbsPercent,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "cbsPercent", $$v)
                              },
                              expression: "form.cbsPercent",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            staticClass: "required",
                            attrs: {
                              id: "tax-configuration-group-cbs-reduction-percent",
                              name: "cbsReductionPercent",
                              type: "text-percetage",
                              currency: "%",
                              precision: 5,
                              validation: "required|number|min:0.0000|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                              label: _vm.$t(
                                "FISCAL_TAX_PARAMETER.LABEL.CBS_REDUCTION_PERCENT"
                              ),
                            },
                            model: {
                              value: _vm.form.cbsReductionPercent,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "cbsReductionPercent", $$v)
                              },
                              expression: "form.cbsReductionPercent",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            staticClass: "required",
                            attrs: {
                              id: "tax-configuration-group-cbs-deferral-percent",
                              name: "cbsDeferralPercent",
                              type: "text-percetage",
                              currency: "%",
                              precision: 5,
                              validation: "required|number|min:0.0000|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                              label: _vm.$t(
                                "FISCAL_TAX_PARAMETER.LABEL.CBS_DEFERRAL_PERCENT"
                              ),
                            },
                            model: {
                              value: _vm.form.cbsDeferralPercent,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "cbsDeferralPercent", $$v)
                              },
                              expression: "form.cbsDeferralPercent",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.cbsIbsRatesVisible
                ? _c(
                    "div",
                    [
                      _c("h6", { staticClass: "mb-1 mt-1" }, [
                        _vm._v(" " + _vm._s(_vm.$t("IBS Estadual")) + " "),
                      ]),
                      _c(
                        "b-row",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("FormulateInput", {
                                staticClass: "required",
                                attrs: {
                                  id: "tax-configuration-group-ibs-state-percent",
                                  name: "ibsStatePercent",
                                  type: "text-percetage",
                                  currency: "%",
                                  precision: 5,
                                  validation:
                                    "required|number|min:0.0000|max:1",
                                  "validation-messages": Object.assign(
                                    {},
                                    _vm.mxGetTextPercentageValidationMessages
                                  ),
                                  label: _vm.$t(
                                    "FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_PERCENT"
                                  ),
                                },
                                model: {
                                  value: _vm.form.ibsStatePercent,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "ibsStatePercent", $$v)
                                  },
                                  expression: "form.ibsStatePercent",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("FormulateInput", {
                                staticClass: "required",
                                attrs: {
                                  id: "tax-configuration-group-ibs-state-reduction-percent",
                                  name: "ibsStateReductionPercent",
                                  type: "text-percetage",
                                  currency: "%",
                                  precision: 5,
                                  validation:
                                    "required|number|min:0.0000|max:1",
                                  "validation-messages": Object.assign(
                                    {},
                                    _vm.mxGetTextPercentageValidationMessages
                                  ),
                                  label: _vm.$t(
                                    "FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_REDUCTION_PERCENT"
                                  ),
                                },
                                model: {
                                  value: _vm.form.ibsStateReductionPercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "ibsStateReductionPercent",
                                      $$v
                                    )
                                  },
                                  expression: "form.ibsStateReductionPercent",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("FormulateInput", {
                                staticClass: "required",
                                attrs: {
                                  id: "tax-configuration-group-ibs-state-deferral-percent",
                                  name: "ibsStateDeferralPercent",
                                  type: "text-percetage",
                                  currency: "%",
                                  precision: 5,
                                  validation:
                                    "required|number|min:0.0000|max:1",
                                  "validation-messages": Object.assign(
                                    {},
                                    _vm.mxGetTextPercentageValidationMessages
                                  ),
                                  label: _vm.$t(
                                    "FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_DEFERRAL_PERCENT"
                                  ),
                                },
                                model: {
                                  value: _vm.form.ibsStateDeferralPercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "ibsStateDeferralPercent",
                                      $$v
                                    )
                                  },
                                  expression: "form.ibsStateDeferralPercent",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("h6", { staticClass: "mb-1 mt-1" }, [
                        _vm._v(" " + _vm._s(_vm.$t("IBS Municipal")) + " "),
                      ]),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("FormulateInput", {
                                staticClass: "required",
                                attrs: {
                                  id: "tax-configuration-group-ibs-municipal-percent",
                                  name: "ibsMunicipalPercent",
                                  type: "text-percetage",
                                  currency: "%",
                                  precision: 5,
                                  validation:
                                    "required|number|min:0.0000|max:1",
                                  "validation-messages": Object.assign(
                                    {},
                                    _vm.mxGetTextPercentageValidationMessages
                                  ),
                                  label: _vm.$t(
                                    "FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_PERCENT"
                                  ),
                                },
                                model: {
                                  value: _vm.form.ibsMunicipalPercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "ibsMunicipalPercent",
                                      $$v
                                    )
                                  },
                                  expression: "form.ibsMunicipalPercent",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("FormulateInput", {
                                staticClass: "required",
                                attrs: {
                                  id: "tax-configuration-group-ibs-municipal-reduction-percent",
                                  name: "ibsMunicipalReductionPercent",
                                  type: "text-percetage",
                                  currency: "%",
                                  precision: 5,
                                  validation:
                                    "required|number|min:0.0000|max:1",
                                  "validation-messages": Object.assign(
                                    {},
                                    _vm.mxGetTextPercentageValidationMessages
                                  ),
                                  label: _vm.$t(
                                    "FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_REDUCTION_PERCENT"
                                  ),
                                },
                                model: {
                                  value: _vm.form.ibsMunicipalReductionPercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "ibsMunicipalReductionPercent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.ibsMunicipalReductionPercent",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("FormulateInput", {
                                staticClass: "required",
                                attrs: {
                                  id: "tax-configuration-group-ibs-municipal-deferral-percent",
                                  name: "ibsMunicipalDeferralPercent",
                                  type: "text-percetage",
                                  currency: "%",
                                  precision: 5,
                                  validation:
                                    "required|number|min:0.0000|max:1",
                                  "validation-messages": Object.assign(
                                    {},
                                    _vm.mxGetTextPercentageValidationMessages
                                  ),
                                  label: _vm.$t(
                                    "FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_DEFERRAL_PERCENT"
                                  ),
                                },
                                model: {
                                  value: _vm.form.ibsMunicipalDeferralPercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "ibsMunicipalDeferralPercent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.ibsMunicipalDeferralPercent",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("hr", { staticClass: "mt-2" }),
              _c("h6", { staticClass: "mb-1" }, [
                _vm._v(" " + _vm._s(_vm.$t("Imposto Seletivo")) + " "),
              ]),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "tax-configuration-group-st-selective-tax",
                          name: "stSelectiveTaxCode",
                          type: "vue-select",
                          options: _vm.comboCst,
                          placeholder: _vm.$t("Mantém o do NCM"),
                          label: _vm.$t("Situação Trib. Imposto Seletivo"),
                          instruction: _vm.$t(
                            "Quando informada, todo o bloco do Imposto Seletivo desta exceção substitui o do parâmetro fiscal do NCM"
                          ),
                        },
                        model: {
                          value: _vm.form.stSelectiveTaxCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "stSelectiveTaxCode", $$v)
                          },
                          expression: "form.stSelectiveTaxCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        class: _vm.hasSelectiveTax ? "required" : "",
                        attrs: {
                          id: "tax-configuration-group-fiscal-classification-selective-tax",
                          name: "fiscalClassificationSelectiveTaxCode",
                          type: "vue-select",
                          options: _vm.comboSelectiveTaxClassTribs,
                          placeholder: _vm.$t("Selecione"),
                          disabled: !_vm.hasSelectiveTax,
                          validation: _vm.hasSelectiveTax ? "required" : "",
                          label: _vm.$t("Classificação Imposto Seletivo"),
                        },
                        model: {
                          value: _vm.form.fiscalClassificationSelectiveTaxCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "fiscalClassificationSelectiveTaxCode",
                              $$v
                            )
                          },
                          expression:
                            "form.fiscalClassificationSelectiveTaxCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        class: _vm.hasSelectiveTax ? "required" : "",
                        attrs: {
                          id: "tax-configuration-group-selective-tax-type",
                          name: "selectiveTaxType",
                          type: "vue-select",
                          options: _vm.comboSelectiveTaxTypes,
                          placeholder: _vm.$t("Selecione"),
                          disabled: !_vm.hasSelectiveTax,
                          validation: _vm.hasSelectiveTax ? "required" : "",
                          label: _vm.$t("Tipo de Imposto Seletivo"),
                        },
                        model: {
                          value: _vm.form.selectiveTaxType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "selectiveTaxType", $$v)
                          },
                          expression: "form.selectiveTaxType",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.hasSelectiveTax &&
                  _vm.form.selectiveTaxType === "PERCENTAGE_BY_BASE_VALUE"
                    ? _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            staticClass: "required",
                            attrs: {
                              id: "tax-configuration-group-selective-tax-percent",
                              name: "selectiveTaxPercent",
                              type: "text-percetage",
                              currency: "%",
                              precision: 4,
                              validation: "required|number|min:0.00|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                              label: _vm.$t("% Imposto Seletivo"),
                            },
                            model: {
                              value: _vm.form.selectiveTaxPercent,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "selectiveTaxPercent", $$v)
                              },
                              expression: "form.selectiveTaxPercent",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hasSelectiveTax &&
                  _vm.form.selectiveTaxType === "PERCENTAGE_BY_UNIT"
                    ? _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            staticClass: "required",
                            attrs: {
                              id: "tax-configuration-group-selective-tax-value-per-unit",
                              name: "selectiveTaxValuePerUnit",
                              type: "text-percetage",
                              currency: "R$",
                              precision: 4,
                              validation: "required|number|min:0.00|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                              label: _vm.$t(
                                "Valor por Unidade Imposto Seletivo"
                              ),
                            },
                            model: {
                              value: _vm.form.selectiveTaxValuePerUnit,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "selectiveTaxValuePerUnit",
                                  $$v
                                )
                              },
                              expression: "form.selectiveTaxValuePerUnit",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }